import React, { useState } from 'react';

const content = {
  about: {
    title: 'About Opiniguru',
    intro: 'Independent journalism built around accuracy, context and a respect for the reader.',
    sections: [['Our purpose', 'Opiniguru is a modern digital publication reporting on Sri Lanka and the world. We publish verified news, original reporting, informed analysis and clearly labelled opinion.'], ['Our standards', 'We seek accuracy before speed, correct mistakes transparently and separate editorial judgment from commercial interests.'], ['Our newsroom', 'Our journalists, editors and contributors bring specialist knowledge and a commitment to fair, public-interest reporting.']]
  },
  privacy: {
    title: 'Privacy Policy',
    intro: 'How Opiniguru handles information and protects reader privacy.',
    sections: [['Information we collect', 'We may collect limited technical, analytics and subscription information required to operate and improve the service.'], ['How information is used', 'Information is used to deliver requested services, understand site performance and protect the security of our systems.'], ['Your choices', 'Readers may request access, correction or deletion of personal information, subject to applicable law.']]
  },
  terms: {
    title: 'Terms & Conditions',
    intro: 'The terms governing access to and use of Opiniguru.',
    sections: [['Using our service', 'Content is provided for personal, non-commercial use unless separate written permission has been granted.'], ['Intellectual property', 'Original Opiniguru reporting, design and branding remain protected by applicable intellectual property laws.'], ['External sources', 'Attributed excerpts and links remain subject to the terms and rights of their original publishers.']]
  },
  'editorial-policy': {
    title: 'Editorial Policy',
    intro: 'Trust begins with clarity about what we publish and how we work.',
    sections: [['News', 'Verified factual reporting produced or carefully curated by our newsroom.'], ['Opiniguru Original', 'Reporting researched, written and edited by Opiniguru journalists.'], ['Opinion and analysis', 'Interpretation and argument are prominently labelled and kept distinct from factual news reporting.'], ['External publications', 'RSS-sourced items retain their publication name, original date and a prominent link to the source. Full text is published only where rights have been obtained.'], ['Corrections', 'Substantive errors are corrected promptly and transparently. Readers can contact the editorial desk with concerns.']]
  }
};

function Contact() {
  const [status, setStatus] = useState('');
  const submit = (event) => {
    event.preventDefault();
    setStatus('Message storage is not connected yet.');
  };
  return (
    <form className="contact-form" onSubmit={submit}>
      <div className="form-grid"><label>Name<input required /></label><label>Email<input type="email" required /></label></div>
      <label>Subject<select><option>General enquiry</option><option>Editorial correction</option><option>Advertising</option><option>Careers</option></select></label>
      <label>Message<textarea required rows="7" /></label>
      <button type="submit">Send message</button>
      {status && <p className="form-message dark">{status}</p>}
      <div data-greta-form-placeholder="CONTACT_FORM">This form is not collecting yet.</div>
    </form>
  );
}

function StaticPage({ type }) {
  const page = type === 'contact' ? { title: 'Contact Opiniguru', intro: 'Reach our editorial, commercial or support teams.' } : content[type];
  return (
    <div className="shell page-space">
      <header className="page-header narrow"><span className="eyebrow">OPINIGURU</span><h1>{page.title}</h1><p>{page.intro}</p></header>
      {type === 'contact' ? <Contact /> : (
        <div className="prose-page">
          {page.sections.map(([title, body]) => <section key={title}><h2>{title}</h2><p>{body}</p></section>)}
          <p className="updated">Last updated: May 18, 2026</p>
        </div>
      )}
    </div>
  );
}

export default StaticPage;